import Vue from 'vue';
import ImageObserver from '#app#/global/ImageIntersectionObserver.js'

Vue.directive('lazy', {
    bind(el, binding) {
        if(binding.modifiers.blur) {
            el.style.filter = 'blur(10px)'
            el.style.transition = 'all 0.5s cubic-bezier(0.165, 0.84, 0.44, 1)'
        }
    },

    inserted(el) {
        ImageObserver.observe(el)
    },
})


// WEBPACK FOOTER //
// ../default-js/js/directives/imageLazyLoad.js